export const CASH_FLOW_LABELS = {
    admin_super_agent: 'Admin → Super Agent',
    super_agent_agent: 'Super Agent → Agent',
    agent_shop: 'Agent → Shop',
    shop_player_deposit: 'Shop → Player (Deposit)',
    shop_player_redemption: 'Player → Shop (Redemption)',
};
export const CASH_FLOW_SHORT_LABELS = {
    admin_super_agent: 'Admin → SA',
    super_agent_agent: 'SA → Agent',
    agent_shop: 'Agent → Shop',
    shop_player_deposit: 'Counter deposit',
    shop_player_redemption: 'Counter redemption',
};
export const CASH_STATUS_LABELS = {
    paid_full: 'Paid in full — credits issued',
    pending_payment: 'Pending payment — credits issued',
    partially_paid: 'Partially paid',
    cancelled: 'Cancelled',
};
export const CASH_PAYMENT_METHOD_LABELS = {
    cash: 'Cash',
    bank_transfer: 'Bank transfer',
    check: 'Check',
    other: 'Other',
};
export const CASH_FLOW_FILTER_OPTIONS = [
    { value: '', label: 'All' },
    { value: 'admin_super_agent', label: 'Admin → Super Agent' },
    { value: 'super_agent_agent', label: 'Super Agent → Agent' },
    { value: 'agent_shop', label: 'Agent → Shop' },
    { value: 'shop_player_deposit', label: 'Shop → Player (Deposit)' },
    { value: 'shop_player_redemption', label: 'Player → Shop (Redemption)' },
];
export const CASH_STATUS_FILTER_OPTIONS = [
    { value: '', label: 'All' },
    { value: 'paid_full', label: CASH_STATUS_LABELS.paid_full },
    { value: 'pending_payment', label: CASH_STATUS_LABELS.pending_payment },
    { value: 'partially_paid', label: CASH_STATUS_LABELS.partially_paid },
    { value: 'cancelled', label: CASH_STATUS_LABELS.cancelled },
];
export const CASH_PAYMENT_METHOD_OPTIONS = [
    { value: 'cash', label: 'Cash' },
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'check', label: 'Check' },
    { value: 'other', label: 'Other' },
];
export const CASH_PAGE_SIZE_OPTIONS = [20, 50, 100];
